import { render } from "./Focus.vue?vue&type=template&id=64dadde8&scoped=true"
import script from "./Focus.vue?vue&type=script&lang=js"
export * from "./Focus.vue?vue&type=script&lang=js"

import "./Focus.vue?vue&type=style&index=0&id=64dadde8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dadde8"]])

export default __exports__